import React from "react";
import ReactECharts from "@/components/EChartsReact";

const BarChart = (props) => {
    const getOption = () => {
        const avgValue = props.data.reduce((sum, d) => sum + d.yField, 0) / props.data.length;
        
        return {
            backgroundColor: '#ffffff',
            title: {
                text: props.title,
                left: 'center',
                top: '2%',
                textStyle: {
                    color: '#396598',
                    fontSize: 14
                }
            },
            xAxis: {
                type: 'category',
                data: props.data.map(item => item.key),
                axisLabel: {
                    show: false
                }
            },
            yAxis: {
                type: 'value'
            },
            series: [{
                data: props.data.map(item => ({
                    value: item.yField,
                    itemStyle: {
                        color: item.isCurrent ? '#70ad47' : '#5B8FF9'
                    }
                })),
                type: 'bar',
                barWidth: '60%',
                markLine: {
                    silent: true,
                    symbol: 'none',
                    label: {
                        show: false
                    },
                    data: [{
                        yAxis: avgValue,
                        lineStyle: {
                            color: '#f00',
                            width: 2,
                            type: 'dashed'
                        }
                    }]
                }
            }],
            tooltip: {
                trigger: 'axis',
                formatter: function (params) {
                    const data = props.data[params[0].dataIndex];
                    return `<ul style='margin:10px; padding:10px'>
                        <li style="padding-bottom:5px">Facility: ${data.facilityName}</li>
                        <li style="padding-bottom:5px">Category: ${data.type}</li>
                        <li>EUI: ${data.yField}</li>
                    </ul>`;
                }
            },
            grid: {
                top: 50,
                right: 20,
                bottom: 20,
                left: 40
            }
        };
    };

    return (
        <ReactECharts 
            option={getOption()} 
            style={{ 
                width: '100%',
                height: 'auto',
                aspectRatio: '10 / 3',
                borderRadius: '8px',
                overflow: 'hidden'
            }}
            notMerge={true}
        />
    );
};

export default BarChart;
